import React from 'react';
import PropTypes from 'prop-types';
import {CrossIconOld} from '../../icons/cross-icon';
import {DropdownElement, Element, RemoveElement} from './dropdown.styled';

export const Item = ({children, onSetInnerRef, value, cy, onKeyDown, showFocus, noPadding, onClick, onRemoveClick}) => {
	const handleRemoveClick = onRemoveClick ? () => onRemoveClick(value) : false;
	const handleClick = () => onClick(value);
	return (
		<DropdownElement
			ref={onSetInnerRef}
			data-cy={cy}
			onKeyDown={onKeyDown}
			showFocus={showFocus}
			noPadding={noPadding}
			onClick={handleClick}
		>
			<Element>{children}</Element>
			{handleRemoveClick && (
				<RemoveElement>
					<CrossIconOld onClick={handleRemoveClick} />
				</RemoveElement>
			)}
		</DropdownElement>
	);
};

Item.propTypes = {
	children: PropTypes.any,
	onSetInnerRef: PropTypes.func,
	value: PropTypes.any,
	cy: PropTypes.string,
	onKeyDown: PropTypes.func,
	showFocus: PropTypes.bool,
	noPadding: PropTypes.bool,
	onClick: PropTypes.func,
	onRemoveClick: PropTypes.func,
};
